/**
 * Game API.
 *
 * @module app/components/crossSell/games/API
 */
import DeviceDetector from '../../DeviceDetector';
import MessageBusTopics from '../../../../common/MessageBusTopics';

/**
 * Add topic listeners.
 * @param {Object} messageBus Pub/sub instance.
 * @returns {void}
 * @private
 */
var addListeners = function addListeners(messageBus) {

    messageBus.subscribe(MessageBusTopics.GAME_GET_DEVICE_INFO, function () {
        publishDeviceInfo(messageBus);
    });

    messageBus.subscribe(MessageBusTopics.GAME_UPDATE_BALANCE, function (topic, data) {

        if (data && data.balance) {
            messageBus.publish(MessageBusTopics.SET_BALANCE, data.balance);
        } else {
            messageBus.publish(MessageBusTopics.REFRESH_BALANCE);
        }
    });

    messageBus.subscribe(MessageBusTopics.GAME_SHOW_DEPOSIT, function () {

        messageBus.publish(MessageBusTopics.GAME_SHOW_PAYMENTS);
        messageBus.publish(MessageBusTopics.SHOW_DEPOSIT, {
            reload: false,
        });
    });

    messageBus.subscribe(MessageBusTopics.GAME_SHOW_WITHDRAW, function () {

        messageBus.publish(MessageBusTopics.GAME_SHOW_PAYMENTS);
        messageBus.publish(MessageBusTopics.SHOW_WITHDRAW, {
            reload: false,
        });
    });
};

/**
 * Publish device info.
 * @param {Object} messageBus Pub/sub instance.
 * @returns {void}
 * @private
 */
var publishDeviceInfo = function publishDeviceInfo(messageBus) {

    messageBus.publishSticky(MessageBusTopics.DEVICE_INFO, {
        'native': DeviceDetector.isNative(),
        'web': !DeviceDetector.isNative(),
        'desktop': !DeviceDetector.isMobile(),
        'mobile': DeviceDetector.isMobile(),
        'tablet': DeviceDetector.isTablet(),
    });
};

var initialised = false;

export default {

    /**
     * Initialise game API.
     * @param {Object} messageBus Pub/sub instance.
     * @returns {void}
     * @public
     */
    init: function (messageBus) {

        if (!initialised) {
            addListeners(messageBus);
        }
        initialised = true;
    },
};
